import React, { Component } from 'react';
import { navToOrders, navToLogout } from 'utils/navigate';
import {
  Layout, Menu, Dropdown, Icon, Drawer, Divider,
} from 'antd';
import isBackOffice from 'utils/appUtils';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';
import translate from 'app/translations';

import solidifiLogo from 'assets/images/solidifi-logo.svg';
import './NavBar.scss';

export class NavBar extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  state = { visible: false };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  render() {
    const { app } = this.props;
    const { hasLoaded, userName } = app;

    const showLogout = (isBackOffice && hasLoaded && userName);

    const login = (
      <Menu defaultSelectedKeys={[]}>
        <Menu.Item
          key="logout"
        >
          <a
            className="nav-tab"
            href="/vxvalue/faces/Logout.jsp"
          >
            {this.t('NavBar.logout')}
          </a>
        </Menu.Item>

      </Menu>
    );

    return (
      <div className="nav-bar box-shadow m-b-16">
        <Layout.Header className="solidifi-navigation-bar">
          <div className="inline-block">
            <div className="brand-logo inline-block float-left"><img src={solidifiLogo} alt="Solidifi Logo" /></div>
            <div className="brand-text desktop-only float-left">
              {this.t('NavBar.brandText')}
            </div>
            {isBackOffice && (
              <Menu
                id="menubar"
                theme="light"
                mode="horizontal"
              >
                <Menu.Item className="nav-menu-item">
                  <button
                    className="nav-button"
                    type="button"
                    onClick={navToOrders}
                  >
                    {this.t('Navigation.backToValues')}
                  </button>
                </Menu.Item>
              </Menu>
            )}
            {isBackOffice && (
              <div id="mobile-drawer">
                <button type="button" className="burger-menu" onClick={this.showDrawer}>
                  <Icon type="menu" style={{ fontSize: 24, color: 'white' }} />
                </button>
                <Drawer
                  placement="left"
                  closable={false}
                  onClose={this.onClose}
                  visible={this.state.visible}
                >
                  <div className="burger-menu-item">
                    <button
                      className="drawer-btn"
                      onClick={navToOrders}
                      type="button"
                    >
                      <div className="burger-menu-item-container">
                        <Icon type="user" className="icon-24 burger-icon" />
                        <span className="burger-text">{userName || ''} </span>
                      </div>
                    </button>
                  </div>
                  <Divider />
                  <div className="burger-menu-item">
                    <button
                      className="drawer-btn"
                      onClick={navToOrders}
                      type="button"
                    >
                      <div className="burger-menu-item-container">
                        <Icon type="left" className="icon-24 burger-icon" />
                        <span className="burger-text">{this.t('Navigation.backToValues')}</span>
                      </div>
                    </button>
                  </div>
                  {showLogout && (
                    <div className="burger-menu-item">
                      <button
                        className="drawer-btn"
                        onClick={navToLogout}
                        type="button"
                      >
                        <div className="burger-menu-item-container">
                          <Icon type="logout" className="icon-24 burger-icon" />
                          <span className="burger-text">{this.t('NavBar.logout')}</span>
                        </div>
                      </button>
                    </div>
                  )}
                </Drawer>
              </div>
            )}

          </div>
          {showLogout && (
            <div className="float-right" id="logout-btn">
              <Dropdown
                overlay={login}
                trigger={['click']}
                placement="bottomRight"
              >
                <button
                  className="nav-button"
                  type="button"
                >
                  <span className="nav-button-content">
                    <span className="nav-bar-user-name">{userName || ''} </span>
                    <Icon type="user" />
                  </span>
                </button>
              </Dropdown>
            </div>
          )}
        </Layout.Header>
      </div>
    );
  }
}

NavBar.propTypes = {
  app: PropTypes.shape({}).isRequired,
};

export default NavBar;
